import React, { Component } from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import {
  Box,
  Card,
  CardContent,
  CardImage,
  Columns,
  Column,
  Container,
  Content,
  Hero,
  HeroBody,
  Icon,
  Media,
  MediaContent,
  MediaRight,
  Subtitle,
  Tile,
  Title
} from 'bloomer'

// import Breadcrumbs from '../components/breadcrumbs'
import Image from '../components/image'
import Head from '../components/head'
import Layout from '../components/layout'
import Link from '../components/link'

import { coreValues, team } from '../content/about'

const TeamImage = styled(Image)`
  height: 16rem;
  margin: 0 auto;
  overflow: visible;
  width: 16rem;

  @media only screen and (min-width: 48rem) {
    height: 12rem;
    width: 12rem;
  }

  @media only screen and (min-width: 64rem) {
    height: 16rem;
    width: 16rem;
  }

  @media only screen and (min-width: 68rem) {
    height: 12rem;
    width: 12rem;
  }

  @media only screen and (min-width: 80rem) {
    height: 16rem;
    width: 16rem;
  }
`

const TeamColumn = styled(Column)`
  min-width: 25%;
`

class About extends Component {
  render() {
    const CoreValues = coreValues.map(coreValue => (
      <Column key={coreValue.title}>
        <Tile
          isChild
          render={props => (
            <Box {...props}>
              <Subtitle isSize={4} style={{ fontWeight: 700, margin: 0 }}>
                {coreValue.title}
              </Subtitle>
              <Content isSize={'small'} style={{ color: 'rgba(246, 247, 247, 1)' }}>
                {coreValue.description}
              </Content>
            </Box>
          )}
          style={{
            background: 'rgba(11, 100, 233, 1)',
            height: '100%'
          }}
        />
      </Column>
    ))

    const TeamAvatars = team.map(member => (
      <TeamColumn
        key={member.name}
        isSize={{
          default: 3,
          desktop: 3,
          tablet: 4,
          mobile: 'full',
          widescreen: 3
        }}
      >
        <Card
          style={{
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            height: '25rem',
            flexFlow: 'column nowrap',
            justifyContent: 'space-around'
          }}
        >
          <CardImage>
            <TeamImage
              alt={`Picture of ${member.name}`}
              className="rounded"
              file={this.props.data[member.name.toLowerCase().replace(/\s/g, '')]}
              imgStyle={{
                width: '100%'
              }}
            />
          </CardImage>
          <CardContent
            style={{
              padding: '1rem'
            }}
          >
            <Media
              style={{
                alignItems: 'flex-end',
                display: 'flex',
                flexFlow: 'row nowrap',
                justifyContent: 'center',
                width: '100%'
              }}
            >
              <MediaContent>
                <Subtitle isSize={5} style={{ fontWeight: 700, margin: '0.5rem 0' }}>
                  {member.name}
                </Subtitle>
                <Content>
                  <Subtitle isSize={6} style={{ margin: '0' }}>
                    <strong>{member.position}</strong>
                  </Subtitle>
                </Content>
              </MediaContent>
              <MediaRight>
                <a href={member.socialProfile}>
                  <Icon
                    className={member.icon}
                    style={{
                      border: '2px solid #363636',
                      borderRadius: '50%',
                      color: '#363636',
                      fontSize: '1.25rem',
                      padding: '0.95rem'
                    }}
                  />
                </a>
              </MediaRight>
            </Media>
            <Content>{member.description}</Content>
          </CardContent>
        </Card>
      </TeamColumn>
    ))

    let HeroSection = (
      <Hero isSize={'medium'} isColor={'light'}>
        <HeroBody>
          <Container hasTextAlign={'centered'}>
            <Title isSize={1} className="huge__centered">
              About Route
            </Title>
            <Subtitle isSize={1} style={{ marginBottom: '4rem' }}>
              The Platform
            </Subtitle>
            <Content
              isSize={'large'}
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: 1000
              }}
            >
              Built for the unique and complex needs of service providers in spaces such as commercial cleaning, Route
              is the only <Link to={`/`}>walkthrough, bidding and job proposal software</Link> that brings together the
              essentials of the sales process in one cross platform solution.
            </Content>
            <Content
              isSize={'large'}
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: 1000
              }}
            >
              Featuring a robust web portal and a mobile app with offline capabilities, Route is fundamentally changing
              the game for service providers with tools never before seen by the industry that transform the way
              companies sell.
            </Content>
            <Content
              isSize={'large'}
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: 1000
              }}
            >
              Walkthrough Builder&#8482; collects and organizes the scope of work in real time while you're actually in
              the prospect's space. After reviewing the information, calculate a bid with Route's Estimator and generate
              a Proposal supercharged by custom templates, personalization, and automation that bring you and your team
              unprecedented visibility, growth, and productivity.
            </Content>
          </Container>
        </HeroBody>
      </Hero>
    )

    let CompanySection = (
      <Hero isSize={'medium'} isColor={'black'}>
        <HeroBody>
          <Container hasTextAlign={'centered'}>
            <Subtitle isSize={1} style={{ marginBottom: '4.5rem' }}>
              The Company
            </Subtitle>
            <Content
              isSize={'large'}
              style={{
                marginBottom: '4.5rem',
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: 1000
              }}
            >
              Coming from a fast growing building services company that started from{' '}
              <Link to={'https://rozaladocleaning.com'}>commercial cleaning in Chicago</Link>, we've gone the extra mile
              to engrain our subject matter expertise in to each and every aspect of the platform. We like to say Route
              was built by service providers, for service providers.
            </Content>
            <Subtitle isSize={2} style={{ fontWeight: 700, marginBottom: '2rem' }}>
              Vision
            </Subtitle>
            <Content
              isSize={'large'}
              style={{
                marginBottom: '4.5rem',
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: 1000
              }}
            >
              Our vision is to usher in the future of work for service providers.
            </Content>
            <Subtitle isSize={2} style={{ fontWeight: 700, marginBottom: '2rem' }}>
              Mission
            </Subtitle>
            <Content
              isSize={'large'}
              style={{
                marginBottom: '4.5rem',
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: 1000
              }}
            >
              Our mission is to revolutionize the sales process for commercial cleaning and building service companies
              with a comprehensive toolkit that establishes data driven standards for bidding while offering our user
              community with ways to grow collectively and profitably.
            </Content>
            <Subtitle isSize={2} style={{ fontWeight: 700, marginBottom: '2rem' }}>
              Core Values
            </Subtitle>
            <Tile isSize={12} isParent>
              <Columns isGrid>{CoreValues}</Columns>
            </Tile>
          </Container>
        </HeroBody>
      </Hero>
    )

    let TeamSection = (
      <Hero isSize={'medium'} isColor={'light'}>
        <HeroBody>
          <Container>
            <Subtitle isSize={1} style={{ marginBottom: '4.5rem', textAlign: 'center' }}>
              The Team
            </Subtitle>
            <Columns isGrid isMultiline>
              {TeamAvatars}
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    return (
      <Layout>
        <Head
          author={'Route'}
          banner={this.props.data.armandobello}
          title={'About'}
          description={'About Route'}
          keywords={['About', 'Route']}
          {...this.props}
        />
        {/* <Breadcrumbs {...this.props} /> */}
        {HeroSection}
        {CompanySection}
        {TeamSection}
      </Layout>
    )
  }
}

export default About

export const query = graphql`
  query AboutQuery {
    victorfuentes: file(relativePath: { eq: "assets/team/victor-fuentes.png" }) {
      ...FluidImage
    }
    rickyregalado: file(relativePath: { eq: "assets/team/ricky-regalado.jpg" }) {
      ...FluidImage
    }
    rickyfunk: file(relativePath: { eq: "assets/team/ricky-funk.jpg" }) {
      ...FluidImage
    }
    domenicoamoroso: file(relativePath: { eq: "assets/team/domenico-amoroso.jpg" }) {
      ...FluidImage
    }
    dominicamoroso: file(relativePath: { eq: "assets/team/dominic-amoroso.jpg" }) {
      ...FluidImage
    }
  }
`

// export const query = graphql`
//   query AboutQuery {
//     armandobello: file(relativePath: { eq: "assets/team/armando-bello.jpg" }) {
//       ...FluidImage
//     }
//     gregberg: file(relativePath: { eq: "assets/team/greg-berg.png" }) {
//       ...FluidImage
//     }
//     ezracook: file(relativePath: { eq: "assets/team/ezra-cook.png" }) {
//       ...FluidImage
//     }
//     victorfuentes: file(relativePath: { eq: "assets/team/victor-fuentes.png" }) {
//       ...FluidImage
//     }
//     joegrotto: file(relativePath: { eq: "assets/team/joe-grotto.png" }) {
//       ...FluidImage
//     }
//     salortiz: file(relativePath: { eq: "assets/team/sal-ortiz.jpg" }) {
//       ...FluidImage
//     }
//     rickyregalado: file(relativePath: { eq: "assets/team/ricky-regalado.png" }) {
//       ...FluidImage
//     }
//     teshshah: file(relativePath: { eq: "assets/team/mitesh-shah.png" }) {
//       ...FluidImage
//     }
//     stephensotor: file(relativePath: { eq: "assets/team/stephen-sotor.png" }) {
//       ...FluidImage
//     }
//     emmasteiber: file(relativePath: { eq: "assets/team/emma-steiber.png" }) {
//       ...FluidImage
//     }
//   }
// `
